// extracted by mini-css-extract-plugin
export default {"page":"jX-z","cartModal":"kX-z","checkout":"lX-z","placeholder":"mX-z","account":"nX-z"};